import {
  CardComponent,
  TextField,
  TypableDropdown,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import React from 'react';
import ReportCreateNewLabelField from '../../atoms/ReportCreateNewLabelField';
import BasicModal from '../../atoms/BasicModal';
import { patientAccessTheme } from '@HomaHealth/ui-component-library';

export interface AddParameterProps {
  name: string;
  description?: string;
  responseType?: string;
   
  onChange: (field: 'name' | 'description' | 'type', value: string) => void;
  onSave: () => void;
  onClose: () => void;
  title?: string;
}

const AddParameter: React.FC<AddParameterProps> = ({
  name,
  description,
  onChange,
  onSave,
  onClose,
  title,
  responseType,
}) => {
  const handleChange = (field: 'name' | 'description' | 'type') => (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    onChange(field, e.target.value);
  };

  return (
    <BasicModal
      title={title ?? 'Add Parameter'}
      open={true}
      isScrollable={true}
      handleClose={onClose}
      saveBtnText={'Save'}
      isSaveButton={true}
      saveBtnAction={onSave}
      saveBtnDisabled={!name}
      children={
        <CardComponent
          title=""
          mainGridStyles={{ background: patientAccessTheme.palette.grey[100] }}
          body={
            <>
              <ReportCreateNewLabelField
                label="Name"
                width="100%"
                component={
                  <TextField
                    value={name}
                    fullWidth
                    height="36px"
                    onChange={handleChange('name')}
                    placeholder="Enter Name"
                  />
                }
              />
              {description !== undefined && (
                <ReportCreateNewLabelField
                  label="Description"
                  width="100%"
                  component={
                    <TextField
                      value={description}
                      fullWidth
                      height="36px"
                      onChange={handleChange('description')}
                      placeholder="Enter Description"
                    />
                  }
                />
              )}
              {responseType !== undefined && (
                <ReportCreateNewLabelField
                  label="Response Type"
                  width="100%"
                  component={
                    <TypableDropdown
                      dropDownOptions={['TEXT', 'BOOLEAN']}
                      dropDownValues={['TEXT', 'BOOLEAN']}
                      value={responseType}
                      handleChange={(e) => {
                        onChange('type', e.target.value as string);
                      }}
                      hideTextField
                      height="36px"
                      placeholder={'Response Type'}
                      width="610px"
                      handleInputChange={() => {}}
                    />
                  }
                />
              )}
            </>
          }
        />
      }
    />
  );
};

export default AddParameter;
